import { asMultiStyleConfig } from '../../utils/theme';
import { getColor } from '../../theme-tools';
var parts = ['container', 'label', 'closeButton'];
var baseStyleContainer = props => ({
  minH: 9,
  minW: 6,
  fontSize: 'xs',
  lineHeight: '1rem',
  fontWeight: 'semibold',
  bg: 'blue.700',
  color: 'white',
  outline: 0,
  border: "2px solid ".concat(getColor(props.theme, 'blue.700')),
  borderRadius: '1.25rem',
  px: 5,
  _focus: {
    boxShadow: 'outline'
  }
});
var baseStyleLabel = {
  lineHeight: '1rem'
};
var baseStyleCloseButton = props => ({
  w: 8,
  h: 8,
  ml: 5,
  mr: -5,
  fontSize: 'xs',
  borderRadius: '1.25rem',
  color: 'white',
  _disabled: {
    opacity: 0.4
  },
  _focus: {
    outline: 'none',
    boxShadow: "0 0 0.1875rem 0.125rem ".concat(getColor(props.theme, 'blue.300')),
    color: 'blue.600',
    bg: 'white'
  },
  _hover: {
    color: 'blue.600',
    bg: 'blue.1140'
  },
  _active: {
    color: 'blue.600',
    bg: 'blue.1140'
  }
});
var baseStyle = props => ({
  container: baseStyleContainer(props),
  label: baseStyleLabel,
  closeButton: baseStyleCloseButton(props)
});
export default asMultiStyleConfig({
  parts,
  baseStyle
});